import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

// ---------- IMPORT IMAGES ----------
import p1 from "./images/lflcan1.png";
import p2 from "./images/lflcan2.png";
import p3 from "./images/lflcan3.png";
import p4 from "./images/lflcan4.png";
import p5 from "./images/lflcan5.png";
import p6 from "./images/lflcan6.png";
import p7 from "./images/lflcan7.png";
import p9 from "./images/lflcan9.png";
import p10 from "./images/lflcan10.png";
import p11 from "./images/lflcan11.png";
import combo1 from "./images/lflcomb1.png";
import combo2 from "./images/lflcomb2.png";
import combo3 from "./images/lflcomb3.png";
import combo4 from "./images/lflcomb4.png";

import pet1 from "./images/lflpet1.png";
import pet2 from "./images/lflpet2.png";
import pet3 from "./images/lflpet3.png";
import pet4 from "./images/lflpet4.png";
import pet5 from "./images/lflpet5.png";
import pet6 from "./images/lflpet6.png";
import pet7 from "./images/lflpet7.png";
import pet8 from "./images/lflpet8.png";
import pet9 from "./images/lflpet9.png";
import pet10 from "./images/lflpet10.png";
import pet11 from "./images/lflpet11.png";

import shot1 from "./images/lflshot1.png";
import shot2 from "./images/lflshot2.png";
import shot3 from "./images/lflshot3.png";
import shot4 from "./images/lflshot4.png";
import shot5 from "./images/lflshot5.png";
import shot6 from "./images/lflshot6.png";
import buck1 from "./images/lflbuck1.png";
import buck2 from "./images/lflbuck2.png";

// ---------- TYPES ----------
type GalleryItem = { img: string; label: string };

type GallerySlide = {
  bg: string;
  items: GalleryItem[];
};

type GalleryCarouselProps = {
  title: string;
  slides: GallerySlide[];
};

// ---------- DATA: BUILD SLIDES ----------

// Base items (you can tweak labels if needed)
const cansItems: GalleryItem[] = [
  { img: p1, label: "Creamy Soda" },
  { img: p2, label: "Berry" },
  { img: p3, label: "Fantasy with Natural Guarana" },
  { img: p4, label: "Fruity Tango" },
  { img: p5, label: "Ginger" },
  { img: p6, label: "Guava" },
  { img: p7, label: "Strawberry & Lime" },
  { img: p9, label: "Tropical" },
  { img: p10, label: "Watermelon" },
  { img: p11, label: "Lemon Squash" },
  { img: combo1, label: "Combo 10 Pack Watermelon" },
  { img: combo3, label: "Combo 10 Pack Pineapple" },
  { img: combo4, label: "Combo 10 Pack Fantasy" },
  { img: combo2, label: "Combo 10 Pack Mixed" },
];

const cansBg = "#6d1b7b";

// 7 slides, 2 products each (last slide reuses a couple so you have exactly 7)
const cansSlides: GallerySlide[] = [
  { bg: cansBg, items: [cansItems[0], cansItems[1]] },
  { bg: cansBg, items: [cansItems[2], cansItems[3]] },
  { bg: cansBg, items: [cansItems[4], cansItems[5]] },
  { bg: cansBg, items: [cansItems[6], cansItems[7]] },
  { bg: cansBg, items: [cansItems[8], cansItems[9]] },
  { bg: cansBg, items: [cansItems[10], cansItems[11]] },
  // extra slide – you can adjust which two you want here
  { bg: cansBg, items: [cansItems[12], cansItems[13]] },
];

const petItems: GalleryItem[] = [
  { img: pet1, label: "Peach Fortified" },
  { img: pet2, label: "Peach Bellini" },
  { img: pet3, label: "Zesty Orange" },
  { img: pet4, label: "Creamy Soda" },
  { img: pet8, label: "Fruity Tango" },
  { img: pet9, label: "Hubbly Bubbly" },
  { img: pet5, label: "Berry (Low Sugar)" },
  { img: pet6, label: "Fantasy (Low Sugar)" },
  { img: pet7, label: "Ginger (Low Sugar)" },
  { img: pet10, label: "Combo 3 Pack Single Variant" },
  { img: pet11, label: "Combo 3 Pack Mixed" },
];

const petBg = "#12394a";

// 4 slides: 3 + 3 + 3 + 2 (combos)
const petSlides: GallerySlide[] = [
  { bg: petBg, items: [petItems[0], petItems[1], petItems[2]] },
  { bg: petBg, items: [petItems[3], petItems[4], petItems[5]] },
  { bg: petBg, items: [petItems[6], petItems[7], petItems[8]] },
  { bg: petBg, items: [petItems[9], petItems[10]] },
];

const shotsItems: GalleryItem[] = [
  { img: shot1, label: "Butterscotch" },
  { img: shot2, label: "Choc Banana" },
  { img: shot3, label: "Choc Orange" },
  { img: shot4, label: "Jam Donut" },
  { img: shot5, label: "Salted Caramel" },
  { img: shot6, label: "Sticky Date" },
  { img: buck1, label: "Bucket 16 Shots Mixed Variants" },
  { img: buck2, label: "Bucket 28 Shots Mixed Variants" },
];

const shotsBg = "#E2853D";

// 3 slides: 3 + 3 + 2 (buckets)
const shotsSlides: GallerySlide[] = [
  { bg: shotsBg, items: [shotsItems[0], shotsItems[1], shotsItems[2]] },
  { bg: shotsBg, items: [shotsItems[3], shotsItems[4], shotsItems[5]] },
  { bg: shotsBg, items: [shotsItems[6], shotsItems[7]] },
];

// ---------- MAIN COMPONENT ----------
export default function ProductGallery() {
  return (
    <div className="w-full">
      {/* 1. Cans & Combos */}
      <GalleryCarousel
        title="Little Fat Lamb Cans & Combos (375 ml)"
        slides={cansSlides}
      />

      {/* 2. PET Series */}
      <GalleryCarousel
        title="Little Fat Lamb PET Series (1.25 ltr)"
        slides={petSlides}
      />

      {/* 3. Shots & Buckets */}
      <GalleryCarousel
        title="Little Fat Lamb Shots & Buckets"
        slides={shotsSlides}
      />
    </div>
  );
}

// ---------- REUSABLE CAROUSEL ----------
function GalleryCarousel({ title, slides }: GalleryCarouselProps) {
  const [index, setIndex] = useState(0);
  const [dir, setDir] = useState<1 | -1>(1);

  const length = slides.length;
  const prevIndex = (index - 1 + length) % length;
  const nextIndex = (index + 1) % length;

  const goTo = (i: number, d: 1 | -1) => {
    setDir(d);
    setIndex((i + length) % length);
  };

  const next = () => goTo(index + 1, 1);
  const prev = () => goTo(index - 1, -1);

  const variants = {
    enter: (direction: 1 | -1) => ({
      x: direction > 0 ? "100%" : "-100%",
      opacity: 0,
      position: "absolute" as const,
    }),
    center: {
      x: 0,
      opacity: 1,
      position: "relative" as const,
    },
    exit: (direction: 1 | -1) => ({
      x: direction > 0 ? "-100%" : "100%",
      opacity: 0,
      position: "absolute" as const,
    }),
  };

  const current = slides[index];
  const count = current.items.length;

  const isTwo = count === 2;

  const containerClass = isTwo
    ? "flex justify-center items-end gap-10 md:gap-20"
    : "flex flex-wrap justify-center items-end gap-8 md:gap-10";

  const itemClass = isTwo
    ? "flex flex-col items-center text-center"
    : "flex flex-col items-center text-center basis-1/3 max-w-[18rem]";

  return (
    <section
      className="relative w-full min-h-[70vh] md:min-h-[80vh] overflow-hidden"
      style={{ backgroundColor: current.bg }}
    >
      {/* SIDE PEEKS */}
      <SidePreview
        side="left"
        img={slides[prevIndex].items[0].img}
        alt="Previous"
      />
      <SidePreview
        side="right"
        img={slides[nextIndex].items[0].img}
        alt="Next"
      />

      {/* SLIDE COUNTER */}
      <div className="absolute top-8 right-6 md:top-10 md:right-10 z-20 text-white/95 font-heading">
        <span className="text-4xl md:text-5xl leading-none">
          {String(index + 1).padStart(2, "0")}
        </span>
        <span className="text-lg md:text-xl align-top opacity-80">
          /{String(length).padStart(2, "0")}
        </span>
      </div>

      {/* MAIN CONTENT */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-14 md:py-16 h-full">
        <div className="flex flex-col items-center gap-8 md:gap-10">
          {/* Title */}
          <h2 className="text-center text-3xl md:text-5xl font-heading text-samCream">
            {title}
          </h2>

          {/* Animated slide with images */}
          <div className="relative w-full">
            <AnimatePresence initial={false} custom={dir} mode="popLayout">
              <motion.div
                key={index}
                custom={dir}
                variants={variants}
                initial="enter"
                animate="center"
                exit="exit"
                transition={{ type: "tween", duration: 0.55 }}
              >
                <div className={containerClass}>
                  {current.items.map((item, i) => (
                    <div key={i} className={itemClass}>
                      <img
                        src={item.img}
                        alt={item.label}
                        className={`object-contain drop-shadow-xl transition-transform duration-300 hover:scale-[1.08] ${
                          isTwo
                            ? "w-[220px] md:w-[320px] lg:w-[360px]"
                            : "w-[200px] md:w-[270px] lg:w-[320px]"
                        }`}
                      />
                      <p className="mt-3 text-sm md:text-base font-semibold text-samCream max-w-[14rem]">
                        {item.label}
                      </p>
                    </div>
                  ))}
                </div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>

      {/* ARROWS */}
      <button
        aria-label="Previous"
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-30
                   text-white/90 hover:text-white text-4xl md:text-5xl select-none"
        style={{ textShadow: "0 2px 8px rgba(0,0,0,0.55)" }}
      >
        &lt;
      </button>
      <button
        aria-label="Next"
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-30
                   text-white/90 hover:text-white text-4xl md:text-5xl select-none"
        style={{ textShadow: "0 2px 8px rgba(0,0,0,0.55)" }}
      >
        &gt;
      </button>
    </section>
  );
}


// ---------- SIDE PREVIEW (copied from ProductShowcase style) ----------
function SidePreview({
  side,
  img,
  alt,
}: {
  side: "left" | "right";
  img: string;
  alt: string;
}) {
  const base =
    "hidden md:block absolute top-1/2 -translate-y-1/2 z-0 opacity-40 pointer-events-none";

  const sidePos =
    side === "left"
      ? "-left-[290px] sm:-left-[250px] md:-left-[230px]"
      : "-right-[290px] sm:-right-[250px] md:-right-[230px]";

  return (
    <img
      src={img}
      alt={alt}
      className={`${base} ${sidePos}`}
      style={{
        width: "360px",
        maxWidth: "32vw",
        objectFit: "contain",
        filter: "drop-shadow(0 10px 24px rgba(0,0,0,0.35))",
      }}
    />
  );
}
